
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"20","rx":"8","fill":"url(#paint0_linear_4738_45474)"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"3","fill":"white"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_4738_45474","x1":"2","y1":"12","x2":"22","y2":"12","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#B46BFA"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#F06359"}})])])])
          )
        }
      }
    